import React from "react";
import { useTranslation } from "react-i18next";

function Cartstatus() {
  const { t } = useTranslation();
 
  return (

    <div className="orderstatus" dangerouslySetInnerHTML={{
      __html: t('cartorder_txt'),
    }}>
      
        </div>

    );
}

export default Cartstatus;
